import type { Address_CreationData } from "@/services/addresses/addressTypes";
import { type Address, type Address_ShippingType, AddressType } from "@/services/addresses/addressTypes";

export const isShippingAddress = (address: Address): address is Address_ShippingType => address.type === AddressType.Shipping;

// API requires always all fields...
export const factoryCreateOrUpdateSimpleData = (street: string, streetNumber: string, city: string, postcode: string, country: string, type: AddressType): Address_CreationData => ({
  externalIdentification: "",
  email: "",
  phone: "",
  name: "",
  street,
  streetNumber,
  city,
  postCode: postcode,
  country,
  type,
});
